var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('submenu-page',{attrs:{"eyebrow":"SCHOOL COMMUNICATION","title":"Communication","description":"Connect with parents, guardians, staff and the wider school community.","count-label":"communication tools"}},[_c('SubMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }